module.exports = __webpack_public_path__ + "static/media/shedule-monograma.eecc23ca.png";